import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const addJobTotal = async ({
  jobId,
  wo,
  proposalId,
  total,
  source = "proposal",
}) => {
  if (!jobId || total == null) return;

  const safeJobId = String(jobId); // 🔒 GUARANTEED STRING

  await setDoc(
    doc(db, "job_totals", safeJobId),
    {
      jobId: safeJobId,
      wo: wo ? String(wo) : safeJobId,
      proposalId: proposalId || null,
      total: Number(total),
      status: "approved",
      source,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};
